import { render, staticRenderFns } from "./historicalRoster.vue?vue&type=template&id=54345cb4&scoped=true&"
import script from "./historicalRoster.vue?vue&type=script&lang=js&"
export * from "./historicalRoster.vue?vue&type=script&lang=js&"
import style0 from "./historicalRoster.vue?vue&type=style&index=0&id=54345cb4&prod&scoped=true&lang=css&"
import style1 from "./historicalRoster.vue?vue&type=style&index=1&id=54345cb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54345cb4",
  null
  
)

export default component.exports